function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { VOLUMES_FOR_SELECTION_DATA_FAIL, VOLUMES_FOR_SELECTION_DATA_RECEIVE, VOLUMES_FOR_SELECTION_DATA_REQUEST } from '@engine/actions/action-types';
/**
 * Action Creators for Volumes for Select
 */

export var requestVolumesForSelectionData = function requestVolumesForSelectionData() {
  return {
    type: VOLUMES_FOR_SELECTION_DATA_REQUEST
  };
};
export var receivedVolumesForSelectionData = function receivedVolumesForSelectionData(data) {
  return {
    type: VOLUMES_FOR_SELECTION_DATA_RECEIVE,
    data: data
  };
};
export var failVolumesForSelectionData = function failVolumesForSelectionData(error) {
  return {
    type: VOLUMES_FOR_SELECTION_DATA_FAIL,
    error: error
  };
};
export function fetchVolumesForSelectionData(url, data) {
  return function (dispatch) {
    dispatch(requestVolumesForSelectionData());
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(_objectSpread({
        authenticity_token: window.CSRF
      }, data))
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(receivedVolumesForSelectionData(json));
    })["catch"](function (error) {
      return dispatch(failVolumesForSelectionData(error));
    });
  };
}